import React, { useState } from 'react';
import { Button, Container, Header, Tab } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import { ProfileEditForm } from './ProfileEditForm';
import { Profile } from '../../app/models/profile';

interface Props {
  bio?: string;
}

const ProfileAboutView: React.FC<Props> = ({ bio }) => {
  const {
    profileStore: { isCurrentUser, profile, updateProfile },
  } = useStore();
  const [editMode, setEditMode] = useState(false);

  const handleProfileUpdate = async (values: Partial<Profile>) => {
    await updateProfile(values);
    setEditMode(false);
  };

  return (
    <Tab.Pane>
      {isCurrentUser && !editMode && (
        <Button
          floated="right"
          basic
          color="green"
          icon="edit"
          onClick={() => setEditMode(true)}
        />
      )}
      <Container style={{ marginTop: 24 }}>
        {editMode && profile && (
          <ProfileEditForm
            displayName={profile?.displayName}
            bio={profile.bio}
            onSave={handleProfileUpdate}
            onCancel={() => setEditMode(false)}
          />
        )}
        {!editMode && (
          <>
            <Header size="medium" content="About" />
            {bio && <p style={{ whiteSpace: 'pre-wrap' }}>{bio}</p>}
          </>
        )}
      </Container>
    </Tab.Pane>
  );
};

export { ProfileAboutView };
